module.exports = __webpack_public_path__ + "static/img/tiancheng01_hq.8c22d7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tiancheng01_hq.png
// module id = 1052
// module chunks = 1